import { get, isEmpty } from 'lodash';
import React from 'react';
import { getParagraphOne } from '../../../common/helpers/ui/dataFilter';
import { handleImageUrl } from '../../../common/helpers/sharpie/imageUrlHelper';
import { generateContentPageTitle } from '../../../common/helpers/ui/pageTitleMetaDescription';
import SeoHeader from '../../seoHeader/SeoHeader';
import { SeoMetaComposerData } from '../../../common/helpers/domain/seoMetaComposerData';
const SEO_IMAGE_WIDTH = 1200;
const SEO_IMAGE_HEIGHT = 630;

interface SEO {
  metadesc?: string;
}

interface FeaturedImage {
  url?: string;
}
interface Post {
  seo?: SEO;
  title?: string;
  featuredImage?: FeaturedImage;
  content?: string;
}
interface ContentSeoHeaderprops {
  post?: Post;
  canonicalLink?: string;
  seoMetaComposerData?: SeoMetaComposerData;
  isPreview?: boolean;
}

const ContentSeoHeader: React.FC<ContentSeoHeaderprops> = ({
  post = {},
  canonicalLink,
  seoMetaComposerData,
  isPreview = false,
}) => {
  const { seo = {}, title, featuredImage, content = '' } = post;
  const seoTitle =
    seoMetaComposerData?.[0]?.tags?.title ||
    seoMetaComposerData?.[0]?.tags?.altTitle ||
    seoMetaComposerData?.[0]?.tags?.altTitleBackup ||
    generateContentPageTitle(title);
  const sharpieImgUri = handleImageUrl(
    get(featuredImage, 'url'),
    SEO_IMAGE_WIDTH,
    SEO_IMAGE_HEIGHT,
  );
  const description =
    seoMetaComposerData?.[0]?.tags?.description ||
    seoMetaComposerData?.[0]?.tags?.altDescription ||
    seoMetaComposerData?.[0]?.tags?.altDescriptionBackup ||
    (!isEmpty(seo.metadesc) ? seo.metadesc : getParagraphOne(content));

  return (
    <SeoHeader
      title={seoTitle}
      description={description}
      canonicalLink={canonicalLink}
      imageUrl={sharpieImgUri}
      ogType="article"
      robots={isPreview ? 'noindex, nofollow' : 'index, follow'}
    />
  );
};

export default ContentSeoHeader;
